(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignListName', {
    bindings: {
      campaign: '<',
      isAffiliate: '<',
      showOfferSummary: '&'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/campaign-list-name/campaign-list-name.view.html'
  });

})();
